import React, { useEffect, useState } from "react";
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import Pagination from "component/common/Pagination/index";
import { Link, useLocation, useHistory } from "react-router-dom";
import { Table, TableHead, TableBody } from "component/common/Table/index";
import { roleList, deleteRole } from "service/StaffsAndRoles";
import DeleteConfirmation from "component/common/DeleteConfirmation";
import { Toast } from "utils/toast";
import edit from "assets/images/edit.svg";
import dustbin from "assets/images/dustbin.svg";
import Loader from "component/common/Loader";

import styles from "./Role.module.scss";
import { getRoleAction } from "utils/helper";

const Role = () => {
  const location = useLocation();

  const history = useHistory();

  const { isOperationAvailable } = getRoleAction("Staffs & Roles");

  const page = new URLSearchParams(location.search).get("page");

  const search = new URLSearchParams(location.search).get("search");

  const roleTitle = ["S.No", "Role", "Permissions", ""];

  let [confirmation, setConfirmation] = useState(false);

  let [id, setId] = useState(null);

  let [roles, setRoles] = useState(null);

  let [totalPages, setTotalPages] = useState();

  useEffect(() => {
    getRoles();
  }, [page, search]);

  const getRoles = async () => {
    try {
      let response = await roleList({
        page: page != null ? page : 1,
        search: search != null ? search : null,
      });
      if (response.status == 200) {
        setRoles(response.data.data.result.data);
        setTotalPages(response.data.data.result.pageMeta.totalPages);
      }
    } catch (error) {
      Toast({ type: "error", message: error?.response?.data?.message });
    }
  };

  const onDelete = async () => {
    try {
      let response = await deleteRole(id);
      if (response.status == 200) {
        toggleConfirmation();
        getRoles();
        Toast({
          type: "success",
          message: "Role has been deleted successfully",
        });
        setId(null);
      }
    } catch (error) {
      Toast({ type: "error", message: error.data.message });
    }
  };

  const handlePageChange = async (event) => {
    if (search != null) {
      await history.push({
        search: `?tab=role&search=${search}&page=${event}`,
      });
    } else {
      await history.push({ search: `?tab=role&page=${event}` });
    }
    setRoles(null);
  };

  const toggleConfirmation = () => {
    setConfirmation(!confirmation);
  };

  const showConfirmation = (id) => {
    setId(id);
    toggleConfirmation();
  };

  if (roles == null) return <Loader />;

  return (
    <>
      <div className="row">
        <div className="col-md-12">
          <Table>
            <TableHead className={styles.role_head} head={roleTitle} />
            <TableBody>
              {roles.length !== 0 ? (
                roles?.map((list, index) => {
                  return (
                    <tr key={index} className={styles.role_body}>
                      <td>
                        {(page != null ? page : 1) == 1
                          ? index + 1
                          : Number(((page != null ? page : 1) - 1) * 10) +
                            Number(index + 1)}
                      </td>
                      <td>{list.name}</td>
                      <td>
                        {list.accessible
                          ?.map(({ module }) => module)
                          .join(", ")}
                      </td>
                      <td>
                        <UncontrolledDropdown>
                          <DropdownToggle tag="span" data-toggle="dropdown">
                            <i className="icon-dots"></i>
                          </DropdownToggle>
                          <DropdownMenu>
                            {isOperationAvailable("Edit") && (
                              <Link
                                to={`/admin/staffs&roles/edit-role/${list._id}`}
                              >
                                <DropdownItem>
                                  <div className="dropdown-items">
                                    <img src={edit} />
                                    <span>Edit</span>
                                  </div>
                                </DropdownItem>
                              </Link>
                            )}
                            {isOperationAvailable("Delete") && (
                              <DropdownItem
                                onClick={() => showConfirmation(list._id)}
                              >
                                <div className="dropdown-items">
                                  <img src={dustbin} />
                                  <span>Delete</span>
                                </div>
                              </DropdownItem>
                            )}
                          </DropdownMenu>
                        </UncontrolledDropdown>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="4" className="no-record">
                    No Records Found
                  </td>
                </tr>
              )}
            </TableBody>
          </Table>
        </div>
      </div>
      {totalPages > 1 && (
        <Pagination
          totalPages={totalPages}
          activePage={page != null ? page : 1}
          onPageChange={handlePageChange}
        />
      )}
      <DeleteConfirmation
        message="Are you sure to delete this role?"
        isOpen={confirmation}
        toggle={toggleConfirmation}
        onSubmit={onDelete}
      />
    </>
  );
};

export default Role;
